import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { RouterModule } from '@angular/router';
import { CmsConfig, ConfigModule, DeferLoadingStrategy, I18nModule } from '@spartacus/core';
import { RecaptchaFormsModule, RecaptchaModule } from 'ng-recaptcha';
import { DynamicFormsModule } from '../../dynamic-forms/dynamic-forms.module';
import { RequestAccountComponent } from './request-account.component';

@NgModule({
  imports: [
    CommonModule,
    DynamicFormsModule,
    I18nModule,
    MatFormFieldModule,
    MatInputModule,
    MatSelectModule,
    ReactiveFormsModule,
    RecaptchaFormsModule,
    RecaptchaModule,
    RouterModule,
    ConfigModule.withConfig({
      cmsComponents: {
        RequestAccountComponent: {
          component: RequestAccountComponent,
          deferLoading: DeferLoadingStrategy.DEFER,
        },
      },
    } as CmsConfig),
    RequestAccountComponent,
  ],
})
export class RequestAccountModule {}
